import { findScrollContainer } from './findScrollContainer';
import { getWindow } from './getWindow';

const scrollIntervals: Record<string, number> = {};

/**
 * Mantiene visible `element` dentro de su contenedor con scroll,
 * compensando un posible header fijo (`fixedOffsetTop`).
 *
 * @param element         Elemento a mostrar.
 * @param fixedOffsetTop  Espacio mínimo desde el top visible (ej: header fijo). Default 0.
 * @param tries           Cuántas reintentos en caso de layout changes. Default 2.
 * @param timeout         Retraso entre reintentos (ms). Default 100.
 * @param scrollId        Identificador opcional para agrupar timeouts.
 */
export function scrollParentIntoElement(
  element: HTMLElement,
  fixedOffsetTop = 0,
  tries = 2,
  timeout = 100,
  scrollId?: string,
): void {
  // Genera un ID único si no se pasa uno
  const id = scrollId ?? `${Date.now()}_${Math.random()}`;
  // Limpia cualquier timeout pendiente con ese ID
  if (scrollIntervals[id]) {
    clearTimeout(scrollIntervals[id]);
  }

  const scrollParent = findScrollContainer(element) as HTMLElement | null;
  if (!scrollParent) {
    return;
  }

  // Rectángulos para cálculo de overflow
  const parentRect = scrollParent.getBoundingClientRect();
  const elemRect = element.getBoundingClientRect();

  // ¿Está por encima del top visible?
  const topOverflow = elemRect.top - (parentRect.top + fixedOffsetTop);
  // ¿Está por debajo del bottom visible?
  const bottomOverflow = elemRect.bottom - parentRect.bottom + fixedOffsetTop;

  if (topOverflow < 0) {
    // Subir scroll justo lo necesario
    scrollParent.scrollTop += topOverflow;
  } else if (bottomOverflow > 0) {
    // Bajar scroll justo lo necesario
    scrollParent.scrollTop += bottomOverflow;
  }

  // Reintenta en caso de cambios de layout (e.g. imágenes cargando)
  if (tries > 0) {
    scrollIntervals[id] = getWindow().setTimeout(() => {
      scrollParentIntoElement(element, fixedOffsetTop, tries - 1, timeout, id);
    }, timeout);
  }
}
